import { ProhibitionRequest } from "types";

const ProhibitionForm: React.FC<{
  prohibitionFormData: any;
  onProhibitionChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onProhibitionSubmit: (e: React.FormEvent) => void;
  isEditingProhibition: boolean;
  onCancel: () => void;
  setProhibitionDataState: React.Dispatch<
    React.SetStateAction<ProhibitionRequest | null>
  >;
}> = ({
  prohibitionFormData,
  onProhibitionChange,
  onProhibitionSubmit,
  isEditingProhibition,
  onCancel,
  setProhibitionDataState,
}) => (
  <form onSubmit={onProhibitionSubmit}>
    <div className="grid grid-cols-2 gap-4 mt-4">
      <div className="flex flex-col">
        <label className="referral-form-label">
          Prohibition Request Registration Number
        </label>
        <input
          type="text"
          placeholder="Enter registration number"
          className="referral-form-field"
          name="prohabition_request_registration_number"
          value={
            prohibitionFormData.prohabition_request_registration_number || ""
          }
          onChange={onProhibitionChange}
        />
      </div>

      <div className="flex flex-col">
        <label className="referral-form-label">Prohibition Request Date</label>
        <input
          type="date"
          className="referral-form-field"
          name="prohabiton_request_date_registrar"
          value={prohibitionFormData.prohabiton_request_date_registrar || ""}
          onChange={onProhibitionChange}
        />
      </div>
    </div>

    <div className="flex justify-end mt-6 gap-4">
      {isEditingProhibition && (
        <button
          type="button"
          onClick={onCancel}
          className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
      )}
      <button
        type="submit"
        className="referral-form-button text-white"
        style={{ padding: "10px", fontSize: "14px" }}
      >
        {isEditingProhibition ? "Update" : "Add"} Prohibition Details
      </button>
    </div>
  </form>
);

export default ProhibitionForm;
